/**
 * CommonJS style imports
 */

require('script-loader!../../../node_modules/flexslider/jquery.flexslider-min');
require('script-loader!../../../node_modules/slick-carousel/slick/slick');
require('script-loader!../../../node_modules/magnific-popup/dist/jquery.magnific-popup.min');
require('./nid/101-ideas.js');
require('./nid/api.js');
require('./nid/colour-picker.js');
require('./nid/elasticsearch.js');
require('./nid/fit-text.js');
require('./nid/frontpage.js');
require('./nid/general.js');
require('./nid/header.js');
require('./nid/inspiration-images.js');
require('./nid/mailinglist.js');
// require( './nid/maps.js' );
require('./nid/page-templates.js');
require('./nid/product.js');
require('./nid/store-finder.js');
require('./nid/page.js');
require('./nid/wishlist.js');
require('./nid/service-booking.js');


/**
 * ES6+ imports
 */

import './woocommerce';

/* Check if home and show splash screen */
jQuery(window).on('load', function () {
  /* KOlla så att home finns i body klassen */
  if (jQuery('body.home').length) {
    jQuery('#myModal').modal('show');
  }
});

// $(document).on('change', '.variation-radios input', function() {
//     $('.variation-radios input:checked').each(function(index, element) {
//       var $el = $(element);
//       var thisName = $el.attr('name');
//       var thisVal  = $el.attr('value');
//       $('select[name="'+thisName+'"]').val(thisVal).trigger('change');
//     });
//   });
//   $(document).on('woocommerce_update_variation_values', function() {
//     $('.variation-radios input').each(function(index, element) {
//       var $el = $(element);
//       var thisName = $el.attr('name');
//       var thisVal  = $el.attr('value');
//       $el.removeAttr('disabled');
//       if($('select[name="'+thisName+'"] option[value="'+thisVal+'"]').is(':disabled')) {
//         $el.prop('disabled', true);
//       }
//     });
//   });

jQuery(document).on('change', '.variation-radios input', function () {
  jQuery('.variation-radios input:checked').each(function (index, element) {
    let el = jQuery(element);
    jQuery('select[name="' + el.attr('name') + '"]').val(el.attr('value')).trigger('change');
    recreateRadioInputs();
  });
});

jQuery(document).on('woocommerce_update_variation_values', function () {
  jQuery('.variation-radios input').each(function (index, element) {
    let el = jQuery(element);
    el.removeAttr('disabled');
    if (jQuery('select[name="' + el.attr('name') + '"] option[value="' + el.attr('value') + '"]').is(':disabled')) {
      $el.prop('disabled', true);
    }
  });
});

// recreate readio inputs based on the select inputs
function recreateRadioInputs() {
  jQuery('.variation-radios input, .variation-radios label').hide();
  jQuery('.variations select').each(function () {
    let inputName = jQuery(this).attr('name');
    jQuery(this).find('option').each(function () {
      let inputVal = jQuery(this).val();
      let radioInput = jQuery('.variation-radios input[value="' + inputVal + '"]');
      jQuery('.variation-radios label[for="' + radioInput.attr('id') + '"]').show();
      radioInput.show();
    });
  });
}


/* Show correct price when product variation is clicked */
jQuery(document).on('click', '.variation-radios .swatches', function () {
  var $selectedSwatch = jQuery(this);
  var priceTargetId = $selectedSwatch.attr('data-priceid');
  var variationID = $selectedSwatch.attr('data-variation_id');

  if (priceTargetId && variationID) {
    jQuery('.price-class').addClass('d-none');
    jQuery('#' + priceTargetId).removeClass('d-none');

    if (variationID === jQuery('#' + priceTargetId).attr('data-variation_id')) {
      jQuery('input[name=variation_id]').val(variationID).trigger('change');
    } else {
      console.error('Mismatch between price target ID and clicked variation ID.');
    }
  } else {
    console.error('Invalid price target ID or variation ID.');
  }
});

jQuery(".palette-color").click(function () {
  jQuery('.color-wrapper').show();


});


jQuery(document).ready(function ($) {

  jQuery(".color-picker-add").on('click', function () {
    var productID = jQuery(this).attr('data-product_id');
    var productName = jQuery(this).attr('data-product_name');

    // Show loading animation
    jQuery(this).append("<div class='loading_ani'></div>");
    jQuery(".loading_ani").show();

    // Ajax to fetch info for custom add to cart button
    jQuery.ajax({
      url: "/wp-admin/admin-ajax.php",
      type: "POST",
      dataType: "json",
      data: {
        action: "custom_add_to_cart",
        product_id: productID,
        product_name: productName
      },
      success: function success(response) {
        // console.log(response); // use for testing

        if (response.mini_cart.length) {
          // Update mini cart and minicart counter
          jQuery("#cart-list").replaceWith(response.mini_cart);
          jQuery('.mm-cart .item-count').html(Number(jQuery('.mm-cart .item-count').html()) + 1);

          // Show minicart
          jQuery('#site-header #cart-list').addClass('is-active');
          jQuery('#dark-bg').addClass('is-active');

          // Hide loading animation
          jQuery(".loading_ani").remove();
          jQuery(".loading_ani").hide();

          // Hide colorpicket modal and backdrop
          jQuery(".colorpicker-modal").hide();
          jQuery(".modal-backdrop").hide();
        }
      }
    });
  });



  jQuery("#dark-bg").on('click', function () {
    if (jQuery('#dark-bg').hasClass('is-active')) {
      jQuery('#dark-bg').removeClass('is-active');
    }

    if (jQuery('#site-header #cart-list').hasClass('is-active')) {
      jQuery('#site-header #cart-list').removeClass('is-active');

    }
  });

  if(jQuery(".supplier-container-new").length){
    jQuery(".supplier-container-new .usp h3").matchHeight();
    jQuery(".supplier-container-new .usp .mm__body-typography").matchHeight();
  }

});


jQuery(document).ready(function ($) {

  $(document).on('click', '#place_order', function (e) {

    if (!$('#terms').is(':checked')) {
      e.preventDefault();
      $('.terms-error').show();
      return false;
    }
  });

   // Get the subdomain
   const host = window.location.hostname;
   const subdomain = host.split('.')[0];
 
   // Get the select element
   const select = document.getElementById("input_8_11");
   if (!select) return;
 
   // Try to preselect the option matching the subdomain
  for (let option of select.options) {
    if (option.value.toLowerCase() === subdomain.toLowerCase()) {
      option.selected = true;
      break;
    }
   }  

});



